import { IconType } from 'react-icons';
import {
  FaAws, FaDocker, FaJenkins, FaPython, FaNodeJs, FaReact, FaHtml5, FaCss3Alt, FaGitAlt, FaGithub, FaGitlab, FaJira, FaConfluence, FaSlack,
} from 'react-icons/fa';
import {
  SiKubernetes, SiTerraform, SiMicrosoftazure, SiGooglecloud, SiOracle, SiServerless, SiAmazondynamodb, SiAmazonaws, SiHelm, SiPacker, SiGithubactions, SiArgo, SiNewrelic, SiPagerduty, SiGrafana, SiPrometheus, SiCheckmarx, SiHashicorp, SiSonarqube, SiShell, SiBitbucket, SiDiscord, SiKong, SiTypescript,
} from 'react-icons/si';
import { GoTerminal } from "react-icons/go";
import { GrVmware } from "react-icons/gr";

export const iconMap: { [key: string]: IconType } = {
  'aws': FaAws,
  'amazon web services': FaAws,
  'aws core services': SiAmazonaws,
  'azure': SiMicrosoftazure,
  'gcp': SiGooglecloud,
  'google cloud platform': SiGooglecloud,
  'oci': SiOracle,
  'oracle': SiOracle,
  'kubernetes': SiKubernetes,
  'eks': FaAws,
  'gke': SiGooglecloud,
  'docker': FaDocker,
  'ecs': FaAws,
  'terraform': SiTerraform,
  'cloudformation': FaAws,
  'helm': SiHelm,
  'kustomize': GoTerminal,
  'packer': SiPacker,
  'serverless': SiServerless,
  'aws cdk': FaAws,
  'boto3': GoTerminal,
  'jenkins': FaJenkins,
  'gitlab ci': FaGitlab,
  'github actions': SiGithubactions,
  'aws developer tools': FaAws,
  'argocd': SiArgo,
  'new relic': SiNewrelic,
  'logz.io': GoTerminal,
  'cribl': GoTerminal,
  'cloudwatch': FaAws,
  'log analytics': SiMicrosoftazure,
  'pagerduty': SiPagerduty,
  'grafana': SiGrafana,
  'prometheus': SiPrometheus,
  'aquasec': GoTerminal,
  'checkmarx': SiCheckmarx,
  'hashicorp vault': SiHashicorp,
  'kms': FaAws,
  'waf': FaAws,
  'sonarqube': SiSonarqube,
  'python': FaPython,
  'shell/bash scripting': SiShell,
  'node.js': FaNodeJs,
  'groovy (jenkins)': FaJenkins,
  'gitlab': FaGitlab,
  'bitbucket': SiBitbucket,
  'github': FaGithub,
  'jira': FaJira,
  'confluence': FaConfluence,
  'servicenow': GoTerminal,
  'slack': FaSlack,
  'microsoft teams': GoTerminal,
  'discord': SiDiscord,
  'kong': SiKong,
  'cloud custodian': GoTerminal,
  'quicksight': FaAws,
  'react': FaReact,
  'javascript': FaNodeJs,
  'typescript': SiTypescript,
  'html5': FaHtml5,
  'css3': FaCss3Alt,
  'git': FaGitAlt,
  'vmware': GrVmware,
  'dynamodb': SiAmazondynamodb,
  'api gateway': FaAws,
};

export const getIconForSkill = (skillName: string): IconType => {
  const lowerCaseSkillName = skillName.toLowerCase();

  // Direct match
  if (iconMap[lowerCaseSkillName]) {
    return iconMap[lowerCaseSkillName];
  }

  // Partial match
  const matchingKey = Object.keys(iconMap).find(key => lowerCaseSkillName.includes(key));
  if (matchingKey) {
    return iconMap[matchingKey];
  }

  return GoTerminal; // Default icon
};
